import { z } from 'zod';

import { EmailSchema } from '@vestigas/utils';

import {
  AI_MODEL_CHOICE_OPTIONS,
  PROCESS_BULK_OPTIONS,
} from '../useMutationUpdateCompanyAiSettings/constants';
import { zodAiModelEntrySchema } from '../useMutationUpdateCompanyAiSettings/validations';

// `AIModelSettingsCustomSettings` in the OpenAPI spec: every field is nullable
// there, unlike the write-side schema in useMutationUpdateCompanyAiSettings,
// which applies form-only defaults (`.prefault(...)`) that don't apply to what
// the API actually returns.
const zodCompanyAiSettingsCustomSettingsResponseSchema = z.object({
  diPlusAiFoundryFieldsToReplace: z.array(z.string()).nullish(),
  languageEncoding: z.string().nullish(),
  modelChoice: z.enum(AI_MODEL_CHOICE_OPTIONS).nullish(),
  processBulk: z.enum(PROCESS_BULK_OPTIONS).nullish(),
  requireIssuer: z.boolean().nullish(),
});

/**
 * What the GET endpoint returns (`AIModelSettingsReturn` in the OpenAPI
 * spec). `aiModel` is a union of a model list and a legacy plain string —
 * consumers already branch on `typeof aiModel === 'string'` to handle both.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company/operation/get_ai_model_settings_by_company_id_vadmin_company__company_id__default_ai_model_settings_get
 */
export const zodCompanyAiSettingsResponseSchema = z.object({
  aiModel: z.union([z.array(zodAiModelEntrySchema), z.string()]).nullish(),
  companyId: z.uuid(),
  customSettings: zodCompanyAiSettingsCustomSettingsResponseSchema.nullish(),
  // The write-side ENVIRONMENT_OPTIONS intentionally excludes "mirror" as a
  // user-selectable choice, but the API can still return it for existing data.
  environment: z.enum(['dev', 'prod', 'staging', 'mirror']).nullish(),
  senderAddresses: z.array(EmailSchema).nullish(),
  senderDomain: z.string().nullish(),
});
